import { call, put, takeLatest } from "@redux-saga/core/effects";
import { ManufacturerTableApi } from "./ManufacturerApi";
import { ManufacturerTableconstant } from "./ManufacturerConstant";
import { ManufacturerTableParser } from "./ManufacturerParser";

function* getManufacturertable() {
  try {
    yield put({ type: ManufacturerTableconstant.MANUFACTURER_TABLE_REQUEST });
    const res = yield call(ManufacturerTableApi.getManufacturerTable);
    ManufacturerTableParser.getManufacturerTableParser(res);
    yield put({
      type: ManufacturerTableconstant.MANUFACTURER_TABLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.MANUFACTURER_TABLE_RESPONSE,
      payload: [],
    });
  }
}
//post

function* postManufacturerSaga(payload) {

  try {
    yield put({
      type: ManufacturerTableconstant.POST_ADD_MANUFACTURER_REQUEST,
    });
    const res = yield call(ManufacturerTableApi.postAddManufacturer, payload);

    yield put({
      type: ManufacturerTableconstant.POST_ADD_MANUFACTURER_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.POST_ADD_MANUFACTURER_RESPONSE,
      payload: [],
    });
  }
}

function* getAddManufacturer() {
  try {
    yield put({ type: ManufacturerTableconstant.GET_ADD_MANUFACTURER_REQUEST });
    const res = yield call(ManufacturerTableApi.getAddManufacturer);

 ManufacturerTableParser.getAddManufacturerTableParser(res);
   

    yield put({
      type: ManufacturerTableconstant.GET_ADD_MANUFACTURER_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.GET_ADD_MANUFACTURER_RESPONSE,
      payload: [],
    });
  }
}

function* getAddConnector() {
  try {
    yield put({
      type: ManufacturerTableconstant.GET_ADD_CONNECTORS_MODEL_REQUEST,
    });
    const res = yield call(ManufacturerTableApi.getAddConnector);
   ManufacturerTableParser.getAddConnectorParser(res);
 
    yield put({
      type: ManufacturerTableconstant.GET_ADD_CONNECTORS_MODEL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.GET_ADD_CONNECTORS_MODEL_RESPONSE,
      payload: [],
    });
  }
}

// ***************
function* postVehicleModelSaga(payload) {

  try {
    yield put({
      type: ManufacturerTableconstant.POST_ADD_VEHICLE_MODEL_REQUEST,
    });
    const res = yield call(ManufacturerTableApi.postAddVehicleModel, payload);
  

    yield put({
      type: ManufacturerTableconstant.POST_ADD_VEHICLE_MODEL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.POST_ADD_VEHICLE_MODEL_RESPONSE,
      payload: [],
    });
  }
}

function* postConnectorsModelSaga(payload) {

  try {
    yield put({
      type: ManufacturerTableconstant.POST_ADD_CONNECTORS_MODEL_REQUEST,
    });
    const res = yield call(
      ManufacturerTableApi.postAddConnectorsModel,
      payload
    );
  

    yield put({
      type: ManufacturerTableconstant.POST_ADD_CONNECTORS_MODEL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.POST_ADD_CONNECTORS_MODEL_RESPONSE,
      payload: [],
    });
  }
}

//get Vechile model saga

function* getVechileModelSaga() {
  try {
    yield put({
      type: ManufacturerTableconstant.GET_ADD_VEHICLE_MODEL_REQUEST,
    });

    const res = yield call(ManufacturerTableApi.getvehicleModelApi);
 
    const Data = ManufacturerTableParser.getManufacturerTableParser(res);
   

    yield put({
      type: ManufacturerTableconstant.GET_ADD_VEHICLE_MODEL_RESPONSE,
      payload: Data,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.GET_ADD_VEHICLE_MODEL_RESPONSE,
      payload: [],
    });
  }
}

//enable/disable
function* VehicleManufactureEnableDisable({ payload }) {
  const { id, status } = payload;


  try {
    yield put({
      type: ManufacturerTableconstant.VEHICLEMANUFACTURE_ENABLE_DISABLE_REQUEST,
    });
    const res = yield call(
      ManufacturerTableApi.VehicleManufatureEnableDisable,
      { id, status }
    );
    const payload = res;
    yield put({
      type: ManufacturerTableconstant.VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: ManufacturerTableconstant.VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

//enable/disable
function* ConnectorsEnableDisable({ payload }) {
  const { id, status } = payload;

  try {
    yield put({
      type: ManufacturerTableconstant.CONNECTORS_ENABLE_DISABLE_REQUEST,
    });
    const res = yield call(ManufacturerTableApi.ConnectorsEnableDisable, {
      id,
      status,
    });
    const payload = res;
    yield put({
      type: ManufacturerTableconstant.CONNECTORS_ENABLE_DISABLE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: ManufacturerTableconstant.CONNECTORS_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

//enable/disable Add vehicle manufactuere

function* AddVehicleManufactureEnableDisable({ payload }) {
  const { id, status } = payload;
  try {
    yield put({
      type: ManufacturerTableconstant.ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_REQUEST,
    });
    const res = yield call(
      ManufacturerTableApi.AddVehicleManufatureEnableDisableApi,
      { id, status }
    );
    const payload = res;
    yield put({
      type: ManufacturerTableconstant.ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: ManufacturerTableconstant.ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

//update add manufacture

function* UpdateManufactureSaga(payload) {

  try {
    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_MANUFACTURER_REQUEST,
    });

    const res = yield call(ManufacturerTableApi.UpdateAddManufacturer, payload);


    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_MANUFACTURER_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_MANUFACTURER_RESPONSE,
      payload: [],
    });
  }
}

//update vehicalmodel

function* UpdateVehicalModelSaga(payload) {

  try {
    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_MODEL_REQUEST,
    });

    const res = yield call(ManufacturerTableApi.UpdateAddVehicalModel, payload);



    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_MODEL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_MODEL_RESPONSE,
      payload: [],
    });
  }
}

//update connector
function* UpdateAddConnectorSaga(payload) {

  try {
    yield put({ type: ManufacturerTableconstant.UPDATE_ADD_CONNECTOR_REQUEST });

    const res = yield call(ManufacturerTableApi.UpdateAddConnector, payload);


    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_CONNECTOR_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_CONNECTOR_RESPONSE,
      payload: [],
    });
  }
}

// Get select vehicle
function* getSelectVehicle() {
  try {
    yield put({ type: ManufacturerTableconstant.GET_SELECT_VEHICLE_REQUEST });
    const res = yield call(ManufacturerTableApi.getSelectVehicle);
  

    yield put({
      type: ManufacturerTableconstant.GET_SELECT_VEHICLE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.GET_SELECT_VEHICLE_RESPONSE,
      payload: [],
    });
  }
}

// Get select vehicle  model
function* getSelectVehicleModel(payload) {
  try {
    yield put({
      type: ManufacturerTableconstant.GET_SELECT_VEHICLE_MODEL_REQUEST,
    });
    const res = yield call(ManufacturerTableApi.getSelectVehicleModel, payload);


    yield put({
      type: ManufacturerTableconstant.GET_SELECT_VEHICLE_MODEL_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.GET_SELECT_VEHICLE_MODEL_RESPONSE,
      payload: [],
    });
  }
}

function* UpdateMapSaga(payload) {

  try {
    yield put({ type: ManufacturerTableconstant.UPDATE_MAP_REQUEST });
    const res = yield call(ManufacturerTableApi.UpdateMapApi, payload);

    yield put({
      type: ManufacturerTableconstant.UPDATE_MAP_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.UPDATE_MAP_RESPONSE,
      payload: [],
    });
  }
}

// 11111

function* ManufactureEnableDisablesaga({ payload }) {
  const { id, status } = payload;
 
  try {
    yield put({
      type: ManufacturerTableconstant.MANUFACTURER_ENABLE_DISABLE_REQUEST,
    });
    const res = yield call(ManufacturerTableApi.ManufatureEnableDisableApi, {
      id,
      status,
    });
    const payload = res;
    yield put({
      type: ManufacturerTableconstant.MANUFACTURER_ENABLE_DISABLE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: ManufacturerTableconstant.MANUFACTURER_ENABLE_DISABLE_RESPONSE,
      payload: [],
    });
  }
}

// add vehicle variant
function* postVehicleVariantSaga(payload) {
 
  try {
    yield put({
      type: ManufacturerTableconstant.POST_ADD_VEHICLE_VARIANT_REQUEST,
    });
    const res = yield call(
      ManufacturerTableApi.postAddVehicleVariantApi,
      payload
    );


    yield put({
      type: ManufacturerTableconstant.POST_ADD_VEHICLE_VARIANT_RESPONSE,
      payload: res,
      // revenue_graph:revenue_graph
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.POST_ADD_VEHICLE_VARIANT_RESPONSE,
      payload: [],
    });
  }
}

//get vehicle variant
function* getVechileVariantSaga() {
  try {
    yield put({
      type: ManufacturerTableconstant.GET_ADD_VEHICLE_VARIANT_REQUEST,
    });

    const res = yield call(ManufacturerTableApi.getvehicleVariantApi);
  
    const Data = ManufacturerTableParser.getAddVehicleVariantParser(res);

    yield put({
      type: ManufacturerTableconstant.GET_ADD_VEHICLE_VARIANT_RESPONSE,
      payload: Data,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.GET_ADD_VEHICLE_VARIANT_RESPONSE,
      payload: [],
    });
  }
}

//edit vehicle variant
function* UpdateVehicalVariantSaga(payload) {

  try {
    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_VARIANT_REQUEST,
    });

    const res = yield call(
      ManufacturerTableApi.UpdateAddVehicleVariant,
      payload
    );


    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_VARIANT_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_VARIANT_RESPONSE,
      payload: [],
    });
  }
}

function* VehicleModelType(payload) {

  try {
    yield put({
      type: ManufacturerTableconstant.VEHICLE_MODEL_TYPE_REQUEST,
    });

    const res = yield call(
      ManufacturerTableApi.vehicleModelTypeId,
      payload
    );

    yield put({
      type: ManufacturerTableconstant.VEHICLE_MODEL_TYPE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ManufacturerTableconstant.UPDATE_ADD_VEHICLE_VARIANT_RESPONSE,
      payload: [],
    });
  }
}

export function* registerManufacturertableSaga() {
  yield takeLatest(
    ManufacturerTableconstant.MANUFACTURER_TABLE_SAGA,
    getManufacturertable
  );
  yield takeLatest(
    ManufacturerTableconstant.VEHICLE_MODEL_TYPE_SAGA,
    VehicleModelType
  );
  yield takeLatest(
    ManufacturerTableconstant.POST_ADD_MANUFACTURER_SAGA,
    postManufacturerSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.POST_ADD_VEHICLE_MODEL_SAGA,
    postVehicleModelSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.POST_ADD_CONNECTORS_MODEL_SAGA,
    postConnectorsModelSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.GET_ADD_VEHICLE_MODEL_SAGA,
    getVechileModelSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.GET_ADD_MANUFACTURER_SAGA,
    getAddManufacturer
  );
  yield takeLatest(
    ManufacturerTableconstant.GET_ADD_CONNECTORS_MODEL_SAGA,
    getAddConnector
  );
  yield takeLatest(
    ManufacturerTableconstant.VEHICLEMANUFACTURE_ENABLE_DISABLE_SAGA,
    VehicleManufactureEnableDisable
  );
  yield takeLatest(
    ManufacturerTableconstant.CONNECTORS_ENABLE_DISABLE_SAGA,
    ConnectorsEnableDisable
  );
  yield takeLatest(
    ManufacturerTableconstant.ADD_VEHICLEMANUFACTURE_ENABLE_DISABLE_SAGA,
    AddVehicleManufactureEnableDisable
  );
  yield takeLatest(
    ManufacturerTableconstant.UPDATE_ADD_MANUFACTURER_SAGA,
    UpdateManufactureSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.UPDATE_ADD_VEHICLE_MODEL_SAGA,
    UpdateVehicalModelSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.UPDATE_ADD_CONNECTOR_SAGA,
    UpdateAddConnectorSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.GET_SELECT_VEHICLE_SAGA,
    getSelectVehicle
  );
  yield takeLatest(
    ManufacturerTableconstant.GET_SELECT_VEHICLE_MODEL_SAGA,
    getSelectVehicleModel
  );
  yield takeLatest(ManufacturerTableconstant.UPDATE_MAP_SAGA, UpdateMapSaga);
  yield takeLatest(
    ManufacturerTableconstant.MANUFACTURER_ENABLE_DISABLE_SAGA,
    ManufactureEnableDisablesaga
  );
  yield takeLatest(
    ManufacturerTableconstant.POST_ADD_VEHICLE_VARIANT_SAGA,
    postVehicleVariantSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.GET_ADD_VEHICLE_VARIANT_SAGA,
    getVechileVariantSaga
  );
  yield takeLatest(
    ManufacturerTableconstant.UPDATE_ADD_VEHICLE_VARIANT_SAGA,
    UpdateVehicalVariantSaga
  );
}
